import React, { ReactElement } from 'react';
import { formatDate } from 'ps-components/Utils/dateUtils';
import { formatNumber } from 'ps-components/Utils/currencyUtils';
import { Link } from 'react-router-dom';
import { PricingVersion } from './types/versions';

export function formatNameCell(name: string, row: PricingVersion): ReactElement {
  return (
    <div className="global-job-matching__text-cell">
      <Link to={`/market-analysis/global-job-matching/${row['id']}`}>{name}</Link>
    </div>
  );
}

export function formatJobCountCell(jobCount: number): ReactElement {
  return <div className="global-job-matching__text-cell">{formatNumber(jobCount)}</div>;
}

export function formatStatusCell(status: string): ReactElement {
  const className = 'global-job-matching__status global-job-matching__status-' + (status ? 'current' : 'draft');
  return <div className={className}>{status ? 'Current' : 'Draft'}</div>;
}

export function formatDateCell(date: string): ReactElement {
  return <div className="global-job-matching__text-cell">{formatDate(date)}</div>;
}

export function formatDefaultTextCell(value: string): ReactElement {
  return <div className="global-job-matching__text-cell">{value}</div>;
}
